<template>
	<div class="containerPage">
		<div class="information">
			<div class="info-left">
				<img v-if='headPortraitPath' :src="baseurl +'/'+ headPortraitPath" class="head" />
				<img v-else src="../../assets/img/headdefault.png" class="head" />
				<!-- <el-avatar class="head" icon="el-icon-user-solid" size="140"></el-avatar> -->
				<div v-if="isEdit">
					<el-upload class="upload-demo" :action="uploadUrl" :limit="1" :on-success="uploadSuccess"
						:before-upload="beforeAvatarUpload" :headers="headersUpload">
						<el-button size="small">{{$t('myInfomation.editeHeadPath')}}</el-button>
					</el-upload>
				</div>
				<div class="counts">
					<div class="flex-item">
						<h5 class="number">{{goodsCount}}</h5>
						<div class="hint">{{$t('myInfomation.stories')}}</div>
					</div>
					<div class="flex-item">
						<h5 class="number">{{readCountSum}}</h5>
						<div class="hint">{{$t('myInfomation.visitors')}}</div>
					</div>
					<div class="flex-item">
						<!-- <h5 class="number">{{unlockCount}}</h5>先改成0不显示 -->
						<h5 class="number">0</h5>
						<div class="hint">{{$t('myInfomation.followers')}}</div>
					</div>
				</div>
				<div class="info-right" v-if="!isEdit">
					<div class="from-row">
						<div class="lable">{{$t('myInfomation.penName')}}</div>
						<div class="info-value">{{userInfo.pseudonym}}</div>
					</div>
					<!-- <div class="from-row">
						<div class="lable">{{$t('myInfomation.realName')}}</div>
						<div class="info-value">{{userInfo.userName}}</div>
					</div>
					<div class="from-row">
						<div class="lable">{{$t('myInfomation.phone')}}</div>
						<div class="info-value">{{userInfo.userPhone}}</div>
					</div>
					<div class="from-row">
						<div class="lable">{{$t('myInfomation.Email')}}</div>
						<div class="info-value">{{userInfo.userEmail}}</div>
					</div> -->
					<el-button type="warning" size="small" class="info-btn" @click="updataInfo">
						{{$t('myInfomation.udpateInfo')}}
					</el-button>
				</div>
				<!-- <el-button type="warning" size="small" class="info-btn" @click="updataInfo">{{$t('myInfomation.udpateInfo')}}</el-button> -->
			</div>
			<!-- 屏蔽个人信息展示，展示广告banner图 -->
			<!-- 			<div class="info-right" v-if="!isEdit">
				<div class="from-row">
					<div class="lable">{{$t('myInfomation.penName')}}</div>
					<div class="info-value">{{userInfo.pseudonym}}</div>
				</div>
				<div class="from-row">
					<div class="lable">{{$t('myInfomation.realName')}}</div>
					<div class="info-value">{{userInfo.userName}}</div>
				</div>
				<div class="from-row">
					<div class="lable">{{$t('myInfomation.phone')}}</div>
					<div class="info-value">{{userInfo.userPhone}}</div>
				</div>
				<div class="from-row">
					<div class="lable">{{$t('myInfomation.Email')}}</div>
					<div class="info-value">{{userInfo.userEmail}}</div>
				</div>
				<el-button type="warning" size="small" class="info-btn" @click="updataInfo">{{$t('myInfomation.udpateInfo')}}</el-button>
			</div> -->
			<div class="info-right" v-if="!isEdit">
				<div class="banner">
					<el-carousel indicator-position="outside">
						<el-carousel-item v-for="(item,index) in bannerList" :key="index">
							<!-- <h3>{{ item }}</h3> -->
							<el-image class="banner-img" :src="imgurl + '/' + item.path"  @click.stop="JumpToUrl(item)"></el-image>
						</el-carousel-item>
					</el-carousel>
				</div>
				<div class="createBook" v-if="goodsCount==0">
					<div class="create_new">
						<img src="../../assets/img/headdefault.png" alt="">
						<span style="font-weight: bold ">No Works!</span>
						<span>Come publish your story here and get the chance to be followed by GW's millions of
							readers!</span>
						<span>Start to write and earnmore benefits! </span>
						<el-button type="warning" size="small" class="info-btn" @click="goCreateBooks">
							{{$t('myInfomation.createNew')}}
						</el-button>
						<div></div>
					</div>
				</div>
				<div class="bookList" v-else>
					<div class="novel_manages">
						<div class="title">
							<span>Novel’s Management</span>
							<div class="manages_right">
								<a @click="goCreateChapter">Submit a Novel</a>
								<a @click="goMore">More>></a>
							</div>
						</div>
						<div class="novel_list">
							<img v-if="lastNovel.converPath!=''" :src="imgurl + '/' + lastNovel.converPath" alt="">
							<img v-else src="../../assets/img/headdefault.png" alt="">

							<div class="novel_info">
								<span style="font-weight: bold ">{{lastNovel.worksName}}</span>
								<el-button type="warning" size="small" class="info-btn" @click="goCreateChapter">
									{{$t('myInfomation.Add_Chapters')}}
								</el-button>
							</div>
						</div>
					</div>
					<div class="novel_manages novel_rili">
						<div class="title">
							<span>Writing Calendar</span>
							<div class="manages_right">
								<div>
									<el-select v-model="value" placeholder="请选择" @change="getBookData">
										<el-option v-for="(item,index) in options" :key="index" :label="item.worksName"
											:value="item.id">
										</el-option>
									</el-select>
								</div>
								<div>
									<el-date-picker v-model="monthValue" type="month" style="width: 120px"
										value-format="yyyy-MM" format="yyyy-MM" placeholder="选择月" @change="changeMonth">
									</el-date-picker>
								</div>
							</div>
						</div>
						<div class="novel_list">
							<el-calendar style="margin: 5px 5px" v-model="nowdate">
								<template slot="dateCell" slot-scope="{date,data }">
									<div v-if="Date.parse(data.day) < new Date()">
										<p class="is-selected" style="margin: 0 auto; text-align: center;">
											{{ data.day.split("-").slice(2).join() }}
											<!-- <p v-if="scheduleData[data.day]" class="cell-text"> -->
										<p v-if="checkOnDate(data.day)" class="cell-text">
											●
										</p>
										<p v-else class="cell-text2">
											●
										</p>
										</p>
									</div>
									<div v-else>
										<p class="is-selected" style="margin: 0 auto; text-align: center;">
											{{ data.day.split("-").slice(2).join() }}
										</p>
									</div>
								</template>
							</el-calendar>
						</div>
						<div class="explain_text">
							<div>
								<span style="margin-right: 10px">
									<e style="color: #55ff00;margin-right: 5px;">●</e>update words
								</span>
								<span>
									<e style="color:#ff0000;margin-right: 5px;">●</e>Miss
								</span>

								<div style="float: right;display: flex;align-items: center;justify-content: center;">
									<el-tooltip
										content="The calculation of the number of publishing days and words is based on UTC+0."
										placement="top">
										<i class="el-icon-warning-outline tipStyle"></i>
									</el-tooltip>
									Total words updated this month: <e style="font-size: 16px;">{{monthWords}} </e>words
								</div>
							</div>
						</div>
					</div>

				</div>
			</div>
			<div class="info-right" v-else>
				<el-form ref="form" :model="userInfo" label-width="120px" label-position="left" size="small">
					<el-form-item :label="$t('myInfomation.penName')" class="info-form-row">
						<el-input v-model="userInfo.pseudonym" disabled
							:placeholder="$t('myInfomation.pleaseInputYourPenName')" class="info-form-item"></el-input>
					</el-form-item>
					<!-- <el-form-item :label="$t('myInfomation.realName')" class="info-form-row">
						<el-input v-model="userInfo.userName" :placeholder="$t('myInfomation.realNameTip')"
							class="info-form-item"></el-input>
					</el-form-item>
					<el-form-item :label="$t('myInfomation.phone')" class="info-form-row">
						<el-input type="number" v-model="userInfo.userPhone"
							:placeholder="$t('myInfomation.pleaseInputPhone')" class="info-form-item"></el-input>
					</el-form-item>
					<el-form-item :label="$t('myInfomation.Email')" class="info-form-row">
						<el-input v-model="userInfo.userEmail" :placeholder="$t('myInfomation.emailFormat')"
							class="info-form-item">
						</el-input>
					</el-form-item> -->
					<el-form-item :label="$t('myInfomation.AboutMe')" class="info-form-row">
						<el-input type="textarea" rows="4" v-model="userInfo.aboutMe"
							:placeholder="$t('myInfomation.AboutMe')" class="info-form-item">
						</el-input>
					</el-form-item>
					<el-form-item class="them-btn">
						<el-button type="warning" class="zhu-btn info-updata-btn" size="medium" @click="comfrimUpdate">
							{{$t('myInfomation.commit')}}
						</el-button>
						<el-button class="info-updata-btn" size="medium" @click="cannelUpdata">
							{{$t('myInfomation.cancel')}}
						</el-button>
					</el-form-item>
				</el-form>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		getAuthorUserInfo,
		getUnlockCount,
		getGoodsCount,
		updateAuthorUserInfo,
		getVisitorCount,
		getBannerListByParams
	} from '../../common/api/home.js'
	import {
		getAuthorWorksList,
		GetAttendanceList,
		GetAttendanceWords,
		GetUserReadCount
	} from '../../common/api/works.js'
	import {
		setParamsUserId
	} from '../../common/utils/params.js'
	import { getToken } from '@/common/utils/auth'
	export default {
		name: 'Information',
		props: {
			// userInfo: {},
			// unlockCount: 0,
			// goodsCount: 0,
			// score: 0
		},
		data() {
			return {
				//上传的请求头
				headersUpload:{
					Authorization:'Bearer ' + getToken()
				},
				scheduleData: {
					'2022-12-07': [],
					'2022-12-06': []
				},
				monthWords: 888, // 月字数
				value: '',
				novelList: [],
				options: [{
					id: '1',
					worksName: '黄金糕'
				}, {
					id: '2',
					worksName: '双皮奶'
				}, {
					id: '3',
					worksName: '双皮奶2'
				}],
				nowdate: new Date(),
				lastNovel: {
					converPath: '',
					worksName: ''
				}, // 最后更新的作品
				userInfo: this.$store.state.userInfo,
				bannerList: [],
				baseurl: process.env.VUE_APP_BASE_API,
				// imgurl: process.env.VUE_APP_BASE_IMGS,
				imgurl: process.env.VUE_APP_NOVEL_API,
				unlockCount: 0,
				goodsCount: 0,
				score: 0,
				readCountSum: 0, // 阅读人数
				userInfo: {},
				certificate: [{
						name: '身份证',
						value: 1
					},
					{
						name: '学生证',
						value: 2
					},
					{
						name: '军官证',
						value: 3
					}
				], // 证件类型
				emailType: ['@qq.com', '@163.com'], // 邮箱类型
				quhao: ['中国 +86'], // 区号
				country: ['中国', '日本'], // 国家
				province: ['广东省', '浙江省'], // 省份
				city: ['深圳市', '广州市'], // 城市
				county: ['龙岗区', '罗湖区'], // 县/区

				certificateType: 1,
				countryStr: '',
				provinceStr: '',
				cityStr: '',
				countyStr: '',
				emailStr: '',
				isEdit: false,
				reqUser: {
					data: {
						id: this.$store.state.userInfo == null ? -1 : this.$store.state.userInfo.id,
						pseudonym: this.$store.state.userInfo == null ? '' : this.$store.state.userInfo.pseudonym
					}
				},
				reqCount: {
					data: {
						CreateUserId: this.$store.state.userInfo == null ? -1 : this.$store.state.userInfo.id
					}
				},
				uploadUrl: process.env.VUE_APP_BASE_API + '/api/Files/UploadFile?dir=Imgs/Headshot',
				fileList: [], // 上传的图片
				headPortraitPath: '', // 头像
				reqWorksData: { // 请求作品参数
					data: {
						page: 1,
						limit: 50,
						id: 0,
						works: {
							userId: this.userInfo.id
						}

					}
				}
			}
		},
		beforeCreate() {
			this.userInfo = JSON.parse(sessionStorage.getItem('vue_admin_template_UserInfo'))
			console.log('this.userInfo', this.userInfo)
		},
		created() {
			if (this.$route.query.type) {
				this.isEdit = true
			}
			// this.userInfo = JSON.parse(sessionStorage.getItem("vue_admin_template_UserInfo"));
			this.loadData()
		},
		computed: {
			monthValue: {
				get: function() {
					return this.nowdate
				},
				// 当我筛选时间的时候调用set方法，赋值给日历组件绑定的v-model
				set: function(newValue) {
					this.nowdate = newValue
				}
			}
		},
		watch: {

		},
		methods: {

			async loadData() {
				console.log('begin loadData')
				await this.loadUserInfo()
				this.loadUnlockCount()
				this.loadGoodsCount() // 获取用户作品列表
				// this.loadScore()
				this.getBannerListByParams()
				console.log('end loadData')
			},
			JumpToUrl(item) {
				console.log('JumpToUrl', item);
				if (item.link.indexOf('http') > -1) {
					window.open(item.link)
				}
			},
			checkOnDate(data) {
				//console.log('checkondate',data);
				//console.log('scheduleData',this.scheduleData);
				for (let index in this.scheduleData) {
					// console.log("item.date",this.scheduleData[index])
					if (this.scheduleData[index].date == data) {
						return true
					}
				}
				return false;
			},
			/*    GetUserReadCount () {
			      // console.log("begin GetUserReadCount");
			      let reqdata = {
			        data: {
			          createUserId: this.userInfo.id
			        }
			      }
			      GetUserReadCount(reqdata).then(res => {
			        if (res.code == 0) {
			          console.log('GetUserReadCount', res)
			          this.readCountSum = res.data[0].readCountSum
			          // console.log("end GetUserReadCount");
			        }
			      })
			    }, */
			getVisitorCount() {
				let reqdata = {
					data: {
						createUserId: this.userInfo.id
					}
				}
				getVisitorCount(reqdata).then(res => {
					if (res.code == 0) {
						console.log('getVisitorCount', res)
						this.readCountSum = res.data
						// console.log("end GetUserReadCount");
					}
				})

			},



			GetAttendanceList() {
				let reqdata = {
					data: {
						bookId: this.lastNovel.id,
						userId: this.userInfo.id,
						attendTime: this.nowdate
					}
				}
				GetAttendanceList(reqdata).then(res => {
					if (res.code == 0) {
						this.scheduleData = res.data
					}
				})
				// 获取书的月写作字数
				GetAttendanceWords(reqdata).then(res => {
					if (res.code == 0) {
						this.monthWords = res.data
					}
				})
			},
			getBookData() {
				this.lastNovel.id = parseInt(this.value)
				// this.reqWorksData.data.id = parseInt(this.value)
				// 根据选择的书 重新获取打卡记录？
				console.log('this.novelList', this.novelList)

				for (let item in this.novelList) {
					console.log('item', this.novelList[item])
					if (this.lastNovel.id == this.novelList[item].works.id) {
						this.lastNovel = this.novelList[item].works
						console.log('this.lastNovel', this.lastNovel)
					}
				}
				this.GetAttendanceList()
				// this.loadGoodsCount()
			},
			changeMonth() {
				this.nowdate = new Date(this.nowdate)
				console.log('this.nowdate ', this.nowdate)
				this.getBookData()
			},
			updataInfo() {
				let routeName = this.$route.name
				if (routeName == 'information') {
					this.isEdit = true
				} else {
					this.$router.push({
						name: 'information',
						query: {
							type: 1
						}
					})
				}
			},
			goSubmitNovel() {
				this.$router.push({
					path: '/work/new'
				})
			},
			goMore() {
				this.$router.push({
					path: '/work/mywork'
				})
			},
			goCreateBooks() {
				this.$router.push({
					path: '/work/new'
				})
			},
			goCreateChapter() {
				this.$router.push({
					path: '/work/writing?id=' + this.lastNovel.id + '&worksName=' + this.lastNovel.worksName +
						'&listtype=1 &buttontype=add'
				})
			},
			cannelUpdata() {
				this.isEdit = false
				this.loadUserInfo()
			},
			uploadSuccess(response, file, fileList) { // 上传图片成功
				this.fileList = []
				if (response.code == 0) {
					this.fileList = response.data
					this.headPortraitPath = this.fileList
					console.log('this.fileList', this.headPortraitPath)
				}
			},
			// 限制图片上传大小
			beforeAvatarUpload(file) {
				// const isJPG = file.type === 'image/jpeg';
				let types = ['image/jpeg', 'image/gif', 'image/bmp', 'image/png', 'image/webp']
				const isJPG = types.includes(file.type)
				const isLt2M = file.size / 1024 / 1024 < 0.1

				if (!isJPG) {
					this.$message.error('上传头像图片只能是 JPG 格式!')
				}
				if (!isLt2M) {
					this.$message.error('上传头像图片大小不能超过 100kb!')
				}
				return isJPG && isLt2M
			},
			comfrimUpdate() { // 确认保存更新
				console.log('this.fileList', this.fileList)
				if (this.fileList.length > 0) {
					this.userInfo.headPortraitPath = this.fileList[0]
				}
				var reqData = {
					data: this.userInfo
				}
				updateAuthorUserInfo(reqData).then(res => {
					if (res.code == 0) {
						this.isEdit = false
						this.loadUserInfo()
						this.$message({
							message: res.msg,
							type: 'success'
						})
					} else {
						this.$message({
							message: res.msg,
							type: 'error'
						})
					}
				})
			},
			setUserInfo(data) { // 接收子组件传递的数据
				this.userInfo = data
			},
			async loadUserInfo() {
				// console.log("begin loadUserInfo");
				const res = await getAuthorUserInfo(this.reqUser)

				if (res.code == 0) {
					this.userInfo = res.data
					// this.headPortraitPath = process.env.VUE_APP_BASE_API + '/' + this.userInfo.headPortraitPath || ''
					console.log('abc', this.userInfo.headPortraitPath)
					this.headPortraitPath = this.userInfo.headPortraitPath

					setParamsUserId(res.data.id)
				}
				// console.log("end loadUserInfo");
				// this.GetUserReadCount() // 获取总用户浏览数
				this.getVisitorCount() // 获取游客浏览记录

			},
			loadUnlockCount() { // 解锁数
				// console.log("begin loadUnlockCount");
				getUnlockCount(this.reqCount).then(res => {
					if (res.code == 0) {
						this.unlockCount = res.data
					} else {
						// this.goodsCount = 0
					}
					// console.log("end loadUnlockCount");
				})
			},
			loadGoodsCount() { // 作品数
				// getGoodsCount(this.reqCount).then(res => {
				// this.reqWorksData.data.userId = this.this.userInfo.id
				// console.log("begin loadGoodsCount");
				getAuthorWorksList(this.reqWorksData).then(res => {
					if (res.code == 0) {
						this.goodsCount = res.total
						this.options = []
						if (res.data.length > 0) {
							this.lastNovel = res.data[0].works // 存放最后更新那本
							this.novelList = res.data // 存放所有的，用于切换考勤时 左边显示对应数据
							this.GetAttendanceList() // 获取书籍考勤
							for (let i in res.data) {
								let data = {
									id: res.data[i].works.id,
									worksName: res.data[i].works.worksName
								}
								this.options.push(data)
							}
							this.value = this.lastNovel.id
						}
						// console.log("end loadGoodsCount");
					} else {
						this.goodsCount = 0
					}
				})
			},
			loadScore() { // 积分
				this.score = 0
			},
			// 此处调的是 小说接口
			getBannerListByParams() {
				// console.log("begin getBannerListByParams");
				let data = {
					data: {
						staus: 2 // 2为作家的banner广告
					}
				}
				getBannerListByParams(data).then((res) => {
					this.bannerList = res.data
					// console.log("end getBannerListByParams");
				})
			}
		}
	}
</script>

<style lang="scss" scoped="scoped">
	.tipStyle {
		color: #FF8900;
		font-size: 20px;
		margin-right: 3px;

	}

	.el-calendar__header {
		display: none;
	}

	.containerPage {
		background-color: transparent;
	}

	.information {
		display: flex;
		flex-direction: row;
		align-items: flex-start;

		.info-left {
			// width: 320px;
			width: 20%;
			height: auto;
			background: #FFFFFF;
			border-radius: 5px;
			display: flex;
			flex-direction: column;
			justify-content: space-between;
			align-items: center;

			.head {
				width: 140px;
				height: 140px;
				border-radius: 50%;
				margin-top: 50px;
				margin-bottom: 20px;
			}

			.text {
				text-align: center;

				.name {
					font-size: 16px;
					font-weight: bold;
					line-height: 26px;
				}

				.authorId {
					color: #A2A2A2;
				}

				.nickName {
					color: #A2A2A2;
				}
			}

			.counts {
				width: 100%;
				display: flex;
				justify-content: center;
				align-items: center;
				margin-bottom: 20px;

				.flex-item {
					flex: 1;
					text-align: center;
					border-right: 1px solid #C4C4C4;

					.number {
						font-weight: bold;
						font-size: 16px;
						line-height: 26px;
						color: #000000;
					}

					.hint {}
				}

				.flex-item:last-child {
					border-right: 0px;
				}
			}

			.info-btn {
				font-size: 15px;
				border: 1px solid #FF8900;
				background-color: #FF8900;
				margin-bottom: 20px;
			}
		}

		.info-right {
			flex: 1;
			padding: 30px 20px;
			margin-left: 20px;
			background-color: #FFFFFF;
			border-radius: 5px;
			width: 80%;
			.banner {
				width: 100%;
				height: 380px;
				background-color: #EAEAEA;
				.banner-img{
					width: 100%;
					height: 100%;
					object-fit: contain;
				}
				/deep/.el-carousel__container {
					position: relative;
					height: 350px;
				}

				.el-carousel__item h3 {
					color: #475669;
					font-size: 18px;
					opacity: 0.75;
					line-height: 300px;
					margin: 0;
				}

				.el-carousel__item:nth-child(2n) {
					background-color: #99a9bf;
				}

				.el-carousel__item:nth-child(2n+1) {
					background-color: #d3dce6;
				}
			}

			.createBook {
				width: 100%;
				height: 350px;

				.create_new {
					display: flex;
					flex-direction: column;
					justify-content: center;
					align-items: center;
					margin: auto;
					margin-top: 10%;
					width: 80%;
					height: 220px;

					img {
						width: 100px;
						height: 100px;
					}

					span {
						margin: 2px;
					}
				}
			}

			.bookList {
				// border: #000000 solid 1px;
				width: 100%;
				height: 380px;
				display: flex;
				flex-direction: row;
				justify-content: center;
				align-items: center;

				.novel_manages {
					// border: #ff0000 solid 1px;
					width: 50%;
					height: 100%;

					.title {
						font-size: 20px;
						font-weight: 600;
						margin: 20px;
						color: #000000;
						display: flex;
						flex-direction: row;
						justify-content: space-between;
						align-items: center;

						.manages_right {
							font-size: 14px;
							display: flex;
							flex-direction: row;
							justify-content: space-between;
							align-items: center;

							a {
								cursor: pointer;
								color: #73abd8;
								margin-right: 10px;
							}
						}

					}

					.novel_list {
						display: flex;
						flex-direction: row;
						justify-content: left;
						align-items: flex-start;

						img {
							width: 125px;
							height: 150px;
						}

						.novel_info {
							display: flex;
							flex-direction: column;
							justify-content: center;
							align-items: center;

							span {
								font-size: 18px;
								font-weight: 400;
								color: #000000;
								margin: 20px;
							}

							.info-btn {
								border-radius: 20px 20px 20px 20px;
								margin-left: 10px;
							}
						}
					}
				}

				.novel_rili {
					.title {
						font-size: 20px;
						font-weight: 600;
						margin: 10px 20px 5px 20px;
						color: #000000;
						display: flex;
						flex-direction: row;
						justify-content: space-between;
						align-items: center;
					}

					.novel_list {
						.el-calendar-table .el-calendar-day {
							height: 10px;
							background-color: #000000;
						}
					}

				}

				.explain_text {
					span {
						color: #000000;
					}
				}

				.writing_calendar {
					border: #ffff00 solid 1px;
					width: 50%;
					height: 100%;
				}
			}

			.from-row {
				border-bottom: 1px solid #EAEAEA;
				padding: 0 5px;
				margin-bottom: 10px;

				.lable {
					font-size: 14px;
					color: #909090;
				}

				.info-value {
					border: 0px;
					height: 30px;
					line-height: 30px;
					width: 100%;
					color: #656565;
				}
			}

			.info-btn {
				font-size: 15px;
				border: 1px solid #FF8900;
				background-color: #FF8900;
				margin-bottom: 20px;
			}

			.info-form-row {
				margin-bottom: 30px;
			}

			.info-form-item {
				width: 50%;
			}

			.info-updata-btn {
				font-size: 15px;
				width: 135px;
				margin-right: 10px;
			}
		}
	}

	.upload-demo {
		border: 1px solid #FF8900;
		border-radius: 6px;
		color: #FF8900;
		margin-top: 20px;
		margin-bottom: 20px;

		button {
			color: #FF8900;
			letter-spacing: 2px;
			font-size: 14px;
			font-weight: 400;
			padding: 0;
			height: 30px;
			width: 90px;
			line-height: 30px;
		}
	}

	.upload-demo:hover {
		background-color: #FF8900;

		button {
			color: #FFFFFF;
		}
	}
</style>
<!--  -->
<style>
	.novel_list .el-calendar-table .el-calendar-day {
		height: 40px;
	}

	.novel_list .pastTime {
		background-color: #55ff00;
	}

	.novel_list .cell-text {
		color: #55ff00;
		margin-top: -5px;
		margin-left: 45%;
	}

	.novel_list .cell-text2 {
		color: #ff0000;
		margin-top: -5px;
		margin-left: 45%;
	}

	.novel_list .el-calendar__header {
		display: none;
	}

	.el-calendar__body {
		padding: 0px 7px 5px;
	}
</style>